import React from 'react';
import { Navigate } from 'react-router-dom';

const SubAdminRoute = ({ children }) => {
    const token = localStorage.getItem('jff_token');
    const role = localStorage.getItem('role');

    if (!token || role !== 'subadmin') {
        return <Navigate to="/subadmin/login" replace />;
    }

    return children;
};

export default SubAdminRoute;
